module.exports = __webpack_public_path__ + "img/open.7b986b28.svg";